import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isIOS } from './device';

/** "Open in Finder" only makes sense on a Mac screen: it is hidden on an iPhone or a phone-sized window */
export function useCanOpenFinder(): boolean {
  const phone = useMediaQuery(useTheme().breakpoints.down('sm'));
  return !isIOS && !phone;
}

export const FINDER_NOTICE =
  'Opening in Finder needs the Mac connection, which is not connected yet. Nothing was opened, moved or changed on your Mac.';
